import { styled, Radio } from "@mui/material";

import { useState } from "react";
import PriestWeeklySchedule from "../priestSchedule/priestWeeklySchedule";
import DevoteePoojaBooking from "./DevoteePoojaBooking";

interface PoojaBookingProps {
  onBackClick: () => void;
}

export const CustomRadioButtons = styled(Radio)`
  & svg {
    color: #f05802;
    height: 20px;
    width: 20px;
  }
`;

const PoojaBooking = (props: PoojaBookingProps) => {
  const [showPriestSchedulingScreen, setShowPriestSchedulingScreen] =
    useState<boolean>(false);

  return (
    <>
      {!showPriestSchedulingScreen ? (
        <DevoteePoojaBooking
          setShowPriestSchedulingScreen={setShowPriestSchedulingScreen}
          onBackClick={props?.onBackClick}
        />
      ) : (
        <PriestWeeklySchedule
          setShowPriestSchedulingScreen={setShowPriestSchedulingScreen}
        />
      )}
    </>
  );
};
export default PoojaBooking;
